import { Component, ComponentFactoryResolver, ViewChild, ViewContainerRef, OnInit } from "@angular/core";
import { ToolMedicalOrderTransitControlComponent } from './tool-medial-order-transit/tool-medical-order-transit-control.component';
import { ToolStudyReportTransitControlComponent } from "./tool-study-report-transit/tool-study-report-transit-control.component";
import { ToolOrientationPatientCallerComponent } from './tool-orientation-patient-caller/tool-orientation-patient-caller.component';
import { ToolScheduleTaskComponent } from './tool-schedule-task/tool-schedule-task.component';

@Component({
  selector: 'app-tool-panel-control',
  templateUrl: './tool-panel-control.component.html',
})
export class ToolPanelControlComponent {

  toolComponent: any;
  tools: ToolControlChild[] = new Array();
  @ViewChild('entry',  { read: ViewContainerRef, static: false}) entry: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    this.tools['MEDICAL_ORDEN_TRANSIT'] = new ToolControlChild('Control transito orden', ToolMedicalOrderTransitControlComponent);
    this.tools['STUDY_REPORT_TRANSIT'] = new ToolControlChild('Control transito informe', ToolStudyReportTransitControlComponent);
    this.tools['ORIENTATION_PATIENT_CALLER'] = new ToolControlChild('Llamador paciente orientador', ToolOrientationPatientCallerComponent);
    this.tools['FACTURACION_SCHEDULE_TASK'] = new ToolControlChild('Tareas programadas', ToolScheduleTaskComponent);
  }

  public initTool(toolTag: string): string {
    if (this.toolComponent) {
      this.entry.remove(this.entry.indexOf(this.toolComponent));
    }
    const tool = this.tools[toolTag];
    const toolFactory = this.componentFactoryResolver.resolveComponentFactory(tool.component);
    this.toolComponent = this.entry.createComponent(toolFactory);
    return tool.name;
  }
}


export class ToolControlChild {
  constructor(public name: string, public component: any) {  }
}
